import { Palette } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Outlet } from 'react-router-dom'

import { LanguageToggle } from './components/LanguageToggle'

export const AuthLayout = () => {
  const { t } = useTranslation('common')

  return (
    <main className="flex min-h-dvh items-center justify-center bg-background p-4">
      <section className="relative w-full max-w-md rounded-lg border border-card-border bg-card p-6 shadow-sm">
        <div className="absolute right-3 top-3">
          <LanguageToggle />
        </div>
        <div className="mb-6 flex items-center justify-center gap-2 text-lg font-semibold">
          <span className="flex h-9 w-9 items-center justify-center rounded bg-primary text-primary-foreground">
            <Palette className="h-5 w-5" aria-hidden="true" strokeWidth={1.5} />
          </span>
          {t('app_name')}
        </div>
        <Outlet />
      </section>
    </main>
  )
}
